import { Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchAuthMe, newloginUser } from "../../APIConfig/CtfConfig";
import "../../index.css";
import CustomizeInput from "../../components/CustomizeInput";
import CustomizeHiddenInput from "../../components/CustomizeHiddenInput";
import { useDispatch, useSelector } from "react-redux";
import { syncUserFromStorage } from "../../RTK/features/sessionUser/sessionUserSlice";
import logo from ".././../assests/bhumilogo.png";
import idrbtLogo from "../../assests/CR4SALogo_Transperant.png";
import ErrorHandler from "../../ErrorHandler";

const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false)
  const pathurl = useSelector((state) => state?.pathUrl?.mode?.currentPath);
  const [inputs, setInputs] = useState({
    username: "",
    password: "",
  });
  const handleEnterKeyPress = (e) => {
    if (e.key === "Enter") {
      handleChangeLogin();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs({
      ...inputs,
      [name]: value,
    });
  };

  const handleChangeLogin = async () => {
    if (!inputs.username || !inputs.password) {
      toast.error("Username and Password are required");
      return;
    }

    try {
      setLoading(true)
      const normalizedInputs = {
        ...inputs,
        username: inputs.username.toLowerCase(),
      };
      const response = await newloginUser(normalizedInputs);
      const accessToken = response?.data?.access_token || response?.data?.access;
      const refreshToken = response?.data?.refresh_token || response?.data?.refresh;
      setLoading(false)
      if (!accessToken) {
        toast.error("Invalid login response. Please try again.");
        return;
      }

      localStorage.setItem("access_token", accessToken);
      if (refreshToken) {
        localStorage.setItem("refresh_token", refreshToken);
      }

      let user = response?.data?.user || null;


      try {
        const me = await fetchAuthMe();
        const meData = me?.data || {};
        user = {
          ...(user || {}),
          ...meData,
          is_admin: Boolean(meData.is_staff || meData.is_admin),
        };
      } catch (error) {
        console.log(error)
      }



      if (user) {
        localStorage.setItem("cyberrange_user", JSON.stringify(user));
      } else {
        localStorage.removeItem("cyberrange_user");
      }

      if (user?.is_verified === false) {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("cyberrange_user");
        dispatch(syncUserFromStorage());
        toast.error("Your account is not verified. Please verify your account to continue or contact to the admin");
        setLoading(false);
        return;
      }



      dispatch(syncUserFromStorage());
      navigate(pathurl ? pathurl : "/");
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };


  return (
    <Stack height="100dvh" width="100%" display="flex" justifyContent="center" >
      <Stack
        width={{ xs: "100%", sm: "100%", md: "50%", lg: "40%", xl: "40%" }}
        display="flex"
        justifyContent="center"
        alignItems="center"
        px={4}
        py={4}

      >
        <img
          src={logo}
          alt="Description of the image"
          style={{ width: "50%", height: "auto" }}
        />
      </Stack>
      <Stack
        width={{ xs: "100%", sm: "100%", md: "50%", lg: "40%", xl: "40%" }}
        display="flex"
        justifyContent="center"
        alignItems="center"
        px={4}

      >
        <Stack
          display="flex"
          width="100%"
          flexDirection="column"
          maxWidth={"400px"}
        >
          <Typography
            style={{ fontWeight: "bold", color: "#F4F4F4" }}
            variant="h1"
            sx={{ mb: 4 }}
          >
            Login
          </Typography>
          <Stack display="flex" flexDirection="column" sx={{ mb: 2 }}>
            <CustomizeInput
              label={"Username"}
              type="text"
              name="username"
              value={inputs.username}
              onChange={handleChange}
              placeholder={"Enter your username"}
            />
          </Stack>
          <Stack>
            <CustomizeHiddenInput
              label="Password"
              type="password"
              name="password"
              value={inputs.password}
              onChange={handleChange}
              placeholder="Enter Password"
              onKeyPress={handleEnterKeyPress}
            />
          </Stack>

          <Stack>
            <Button
              sx={{
                marginTop: "26px",
                width: "100%",
              }}
              variant="contained"
              color="secondary"
              onClick={handleChangeLogin}
              disabled={loading}
            >
              Continue
            </Button>

          </Stack>
        </Stack>
      </Stack>
      <Stack
        alignItems="end"
        sx={{ justifyContent: "center", alignItems: "center" }}
        width={{ xs: "0%", sm: "0%", md: "50%", lg: "60%", xl: "60%" }}
        position="fixed"
        right={0}
      >
        <img
          src={idrbtLogo}
          alt="login-img"
          style={{
            width: "50%", cursor: "default",
            objectFit: "contain",
            filter: "drop-shadow(0 0 10px #00E0FF)",
            borderRadius: "20px"

          }}
        />
      </Stack>
    </Stack>
  );
};

export default LoginPage;
